import { useEffect } from 'react';

import useClientSideRouting from 'state/clientSideRoutingStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

import { usePathname } from 'hooks/navigation';
import useLandingRedirect from 'hooks/useLandingRedirect';
import useReportSessionData from 'hooks/useReportSessionData';

const NoPreloadedFallback = () => {
  const path = usePathname();
  const redirectToLanding = useLandingRedirect();
  const clientSidePath = useClientSideRouting(store => store.path);
  const initialPreloaded = useSoundsPreloadStore(
    store => store.initialPreloaded
  );
  const reportSessionData = useReportSessionData();

  useEffect(() => {
    // report session data is initialized as undefined
    // if no data is found it is set to null
    if (reportSessionData === undefined) return;

    if (path === '/address-not-supported') return;

    if (reportSessionData) {
      if (
        [
          '/landing',
          '/',
          '/thank-you',
          '/report',
          '/report/bushfire',
          '/report/storm',
          '/report/cyclone',
          '/report/flood',
          '/about-the-project',
        ].includes(path)
      )
        return;

      if (initialPreloaded) return;
    } else {
      if (['/landing', '/', '/about-the-project'].includes(path)) return;
      if (initialPreloaded) return;
    }

    redirectToLanding();
  }, [
    path,
    clientSidePath,
    initialPreloaded,
    reportSessionData,
    redirectToLanding,
  ]);

  return null;
};

export default NoPreloadedFallback;
